/* -------------------------------------------------------------------------- */
/* ---------------------------- MAP : FRAMEWORKS ---------------------------- */

// FRAMEWORKS : NODES_MODULES
import "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster.js";

/* -------------------------------------------------------------------------- */
/* --------------------------- MAP : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	initLeafletMap();
});

/* -------------------------------------------------------------------------- */
/* ------------------------- MAP : GLOBAL FUNCTIONS ------------------------- */

// Centrer une carte sur la position de l'utilisateur
function initialPosition(map) {
	const urlParams = new URLSearchParams(window.location.search);
	const city = urlParams.get("ville");
	const country = urlParams.get("pays");
	if (city || country) {
		// Utiliser l'API de Nominatim pour obtenir les coordonnées de la ville
		const nominatimUrl = `https://nominatim.openstreetmap.org/search?${
			city ? "city" : "country"
		}=${encodeURIComponent(city ? city : country)}&format=json&limit=1`;

		fetch(nominatimUrl)
			.then((response) => response.json())
			.then((data) => {
				if (data.length > 0) {
					const lat = data[0].lat;
					const lon = data[0].lon;
					map.setView([lat, lon], city ? 7 : 5); // zoom à 7 ou 6
				} else {
					console.error("La ville spécifiée n'a pas pu être trouvée.");
				}
			})
			.catch((error) =>
				console.error("Erreur lors de l'appel à l'API de Nominatim : " + error)
			);
	} else if ("geolocation" in navigator) {
		navigator.geolocation.getCurrentPosition(
			function (position) {
				const userLatitude = position.coords.latitude;
				const userLongitude = position.coords.longitude;
				map.setView([userLatitude, userLongitude]);
			},
			function (error) {
				console.error("Erreur de géolocalisation : " + error.message);
			}
		);
	} else {
		console.error(
			"La géolocalisation n'est pas prise en charge par ce navigateur."
		);
	}
}

// Leaflet : Initialisation de la map city
async function initLeafletMap() {
	const mapArea = document.querySelector("#reseau-city");

	if (mapArea) {
		// Initialisation de la map
		const leafletMap = L.map(mapArea, {
			center: [47.5, 3.5], // Centré sur France/Europe
			zoom: 5,
			scrollWheelZoom: true,
		});
		L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
			leafletMap
		);

		// Si possible, recentrer la map
		initialPosition(leafletMap);

		// Obtenir l'URL actuelle
		const searchParams = window.location.search;
		// const jsonURL = `http://localhost/WORDPRESS/my-ebp-village/localisations/?ajax=1&${searchParams.slice(1)}`;
		const jsonURL = `https://www.ebp-village.org/localisations/?ajax=1&${searchParams.slice(1)}`;

		// Récupération des données
		const response = await fetch(jsonURL).then((data) => {
			return data.json();
		});

		const marker_clusters = [];

		const countries = [...new Set(response.map((location) => location.city))];

		countries.forEach((city) => {
			if (city == null) {
				return;
			}
			const locations = response.filter((member) => {
				return member.city === city;
			});
			marker_clusters.push({
				name: city,
				members: locations,
			});
		});

		// Création de clusters à partir des pays
		marker_clusters.forEach(async (cluster) => {
			try {
				const clusterInstance = await createClusters(leafletMap, cluster);
			} catch (_e) {
				console.warn(_e);
			}
		});
	}
}

// Initialisation d'un cluster sur une map
async function createClusters(map, item) {
	try {
		// Initiate cluster
		const cluster = L.markerClusterGroup({
			zoomToBoundsOnClick: false,
			showCoverageOnHover: false,
			singleMarkerMode: true,
			spiderfyOnMaxZoom: false,
			maxClusterRadius: 100,
			animate: false,
		});

		const markers = [];

		item.members.forEach((location) => {
			const marker = L.marker(
				[
					location.coordinates.split(",")[0],
					location.coordinates.split(",")[1],
				],
				{
					icon: L.divIcon({
						html: `
							<div class="marker">
								<i class="marker__icon">
									<svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 19.5 24">
										<path fill="currentColor"
											d="M9.75 0C4.36 0 0 4.36 0 9.75 0 13.4 3.29 18.16 9.75 24c6.46-5.72 9.75-10.6 9.75-14.25C19.5 4.36 15.14 0 9.75 0Zm0 13.4c-2.02 0-3.65-1.64-3.65-3.65s1.64-3.66 3.65-3.66 3.66 1.64 3.66 3.66-1.64 3.65-3.66 3.65Z" />
									</svg>
								</i>
							</div>
						`,
					}),
				}
			);

			marker.on("click", () => handleFromMap(item.name));
			markers.push(marker);
		});

		// Add the markers to the cluser
		cluster.addLayers(markers);

		// Add the markers to the cluser
		const city = item.name;
		cluster.on("clusterclick", () => handleFromMap(city));

		// Add cluster on map
		map.addLayer(cluster);
	} catch (_e) {
		console.warn(_e);
	}
}

// Event when hovering a cluster
function handleFromMap(city) {
	const urlParams = new URLSearchParams(window.location.search);
	urlParams.set("ville", city);
	window.location.href =
		window.location.pathname + "?" + urlParams.toString() + "#resultats";
}
